"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsUnsupportedBrowser = exports.getUserAgentResult = exports.BrowserSupportType = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const isServer_1 = __importDefault(require("./isServer"));
var BrowserSupportType;
(function (BrowserSupportType) {
    BrowserSupportType[BrowserSupportType["Supported"] = 0] = "Supported";
    BrowserSupportType[BrowserSupportType["ShowOnSupportPage"] = 1] = "ShowOnSupportPage";
    BrowserSupportType[BrowserSupportType["ShowBanner"] = 2] = "ShowBanner";
})(BrowserSupportType = exports.BrowserSupportType || (exports.BrowserSupportType = {}));
const getUserAgentResult = (userAgent) => {
    const parser = new ua_parser_js_1.UAParser(userAgent);
    const result = parser.getResult();
    // Detect privacy browsers
    if (!isServer_1.default) {
        const isBrave = (navigator.brave && navigator.brave.isBrave()) || false;
        if (isBrave) {
            result.browser = {
                name: 'Brave',
                version: '',
                major: '',
            };
        }
    }
    const isDuckDuckGo = result.ua.includes('DuckDuckGo');
    if (isDuckDuckGo) {
        result.browser = {
            name: 'DuckDuckGo',
            version: '',
            major: '',
        };
    }
    return result;
};
exports.getUserAgentResult = getUserAgentResult;
const getIsUnsupportedBrowser = (browser, browserVersion) => {
    const unsupportedBrowserNames = ['IE', 'Brave', 'DuckDuckGo'];
    const isUnsupportedBrowserName = unsupportedBrowserNames.includes(browser);
    if (isUnsupportedBrowserName) {
        return BrowserSupportType.ShowBanner;
    }
    if (!browserVersion) {
        return BrowserSupportType.Supported;
    }
    const [majorVersionString] = browserVersion === null || browserVersion === void 0 ? void 0 : browserVersion.split('.');
    const majorVersion = Number(majorVersionString);
    const androidBrowserCutoff = browser === 'Android Browser' && majorVersion < 85;
    const chromeCutoff = browser === 'Chrome' && majorVersion < 85;
    const edgeCutoff = browser === 'Edge' && majorVersion < 85;
    const firefoxCutoff = browser === 'Firefox' && majorVersion < 82;
    const operaCutoff = browser === 'Opera' && majorVersion < 70;
    const safariCutoff = browser === 'Safari' && majorVersion < 11;
    const safariIosCutoff = browser === 'Mobile Safari' && majorVersion < 11;
    const samsungBrowserCutoff = browser === 'Samsung Browser' && majorVersion < 9;
    if ([
        androidBrowserCutoff,
        chromeCutoff,
        edgeCutoff,
        firefoxCutoff,
        operaCutoff,
        safariCutoff,
        safariIosCutoff,
        samsungBrowserCutoff,
    ].some(Boolean)) {
        return BrowserSupportType.ShowOnSupportPage;
    }
    return BrowserSupportType.Supported;
};
exports.getIsUnsupportedBrowser = getIsUnsupportedBrowser;
//# sourceMappingURL=deviceUtils.js.map